import axios from 'axios'
import M from 'materialize-css'

import { modalOpenHandler } from './constant'

export const ModalHandler = (() => {
	const getModalInstance = (elementId: string): M.Modal | null => {
		const modalElement = document.getElementById(elementId)

		if (modalElement === null) {
			return null
		}

		if (!modalElement.matches(modalOpenHandler.selector.modal)) {
			return null
		}

		return M.Modal.getInstance(modalElement)
	}
	const openModal = (elementId: string) => {
		setTimeout(() => {
			getModalInstance(elementId)?.open()
		}, 5)
	}

	const closeModal = (elementId: string) => {
		getModalInstance(elementId)?.close()
	}

	const processResponsePayload = (payload: any) => {
		if (payload instanceof Object) {
			if (modalOpenHandler.data.openModalIdKey in payload) {
				openModal(payload[modalOpenHandler.data.openModalIdKey])
				return
			}

			if (modalOpenHandler.data.closeModalIdKey in payload) {
				closeModal(payload[modalOpenHandler.data.closeModalIdKey])
			}
		}
	}

	const initHandler = () => {
		axios.interceptors.response.use((response) => {
			const { data } = response

			processResponsePayload(data)

			return response
		})

		// @ts-ignore
		$.nette.ext({
			success: processResponsePayload,
		})
	}

	const init = () => {
		initHandler()
	}

	return {
		init,
	}
})()
